import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.186 3.4H15.6a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1v5.4a1 1 0 1 1-2 0V4.815l-8.494 8.493a1 1 0 0 1-1.414-1.414l8.494-8.492ZM6 3.4A2.6 2.6 0 0 0 3.4 6v12A2.6 2.6 0 0 0 6 20.6h12a2.6 2.6 0 0 0 2.6-2.6v-4.8a1 1 0 1 1 2 0V18a4.6 4.6 0 0 1-4.6 4.6H6A4.6 4.6 0 0 1 1.4 18V6A4.6 4.6 0 0 1 6 1.4h4.8a1 1 0 1 1 0 2H6Z"
  />,
  'LinkExternal'
)
